import React, {
  ChangeEventHandler,
  FocusEventHandler,
  InputHTMLAttributes,
} from 'react'
import * as S from './styles'

type InputTypes = InputHTMLAttributes<HTMLInputElement>

type InputProps = {
  label?: string
  labelColor?: string
  type: string
  hasNotArrowNumber?: boolean
  name: string
  placeholder?: string
  hasTestInput?: boolean
  error?: string
  value?: string | number
  onChange?: ChangeEventHandler | undefined
  onBlur?: FocusEventHandler | undefined
} & InputTypes

const Input = ({
  label,
  labelColor,
  hasTestInput = false,
  hasNotArrowNumber = false,
  type,
  name,
  value,
  onChange,
  error,
  onBlur,
  ...props
}: InputProps) => (
  <S.Wrapper className="input" hasTestInput={hasTestInput} hasNotArrowNumber={hasNotArrowNumber}>
    <label style={{ color: labelColor }} htmlFor={name}>
      {label}
    </label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
    {error && <p className="error">{error}</p>}
  </S.Wrapper>
)

export default Input
